import Cookies from "js-cookie"
import { baseURL } from "../api"
import { AppState, useAppSelector } from "../store"
import { useNavigate } from "react-router-dom"
import { useSnackbar } from "./useSnackbar"

export const useLogout = () =>{
    const userObj = useAppSelector((state:AppState)=>state.commonSlice.userObj)
    const navigate = useNavigate()
    const {showSuccess} = useSnackbar()
    const logout = async()=>{
    const headers:any = { 
        'Content-Type': 'application/json',
        'access-token': Cookies.get('accessToken'),
        'refresh-token':Cookies.get('refreshToken')
     }
    const logoutCall = await fetch(`${baseURL}/auth/logout/${userObj.email}`,{
        method: 'post',
        headers,
      })
      const logoutResponse = await logoutCall.json()
      showSuccess(logoutResponse.message,'user-logout-success')
      Cookies.remove('accessToken')
      Cookies.remove('refreshToken')
      navigate('/login')
    }
    
      return {logout} 
}